import { IoCloseOutline } from "react-icons/io5";
import styled from "styled-components";

export const SingleWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 5rem;
  margin-top: 10px;
`;

export const SideBySideWrapperDiv = styled.div`
  display: inline-flex;
  justify-content: space-between;
  min-height: 5rem;
  gap: 20px;
`;

export const SubHeaderDiv = styled.div`
  color: #595959;
  font-size: 12px;
  padding-top: 2em;
`;

export const SingleSubTitleDiv = styled.div`
  color: #000000;
  font-size: 16px;
  padding-top: 0.25em;
`;

export const SideBySideSubTitleDiv = styled(SingleSubTitleDiv)`
  &&& {
    width: 9rem;
  }
`;

export const StatusDiv = styled.div`
  width: max-content;
  border: 1px solid #000000;
  border-radius: 1.25rem;
  padding: 0.5em;
`;
export const Error = styled.div`
  color: #f40012;
  margin-top: 5px;
  max-width: 400px;
  font-size: 14px;
`;
export const GoogleLink = styled.div`
  color: #1976d2;
  max-width: 400px;
  text-overflow: ellipsis;
  font-size: 14px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;

export const StyledButton = styled.button`
  border: none;
  background: #ffffff;
  cursor: pointer;
`;

export const StyledCloseOutline = styled(IoCloseOutline)`
  &&& {
    vertical-align: middle;
    font-size: 2.5rem;
  }
`;

export const LongerSingleWrapperDiv = styled(SingleWrapperDiv)`
  &&& {
    height: 6.5625rem;
  }
`;
